import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'
import userStore from './user'
import createMultiTabState from 'vuex-multi-tab-state';


Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        userStore,
    },
    plugins: [
        createMultiTabState(),
        createPersistedState({
            key: 'resolved'
        })]

})